import SectionBox from "../layout/SectionBox";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTestimonialStore } from "../../store/testimonialStore";
import PageLoader from "../../components/atoms/PageLoader";

export default function Testimonial() {
  const [slidesToScroll, setSlidesToScroll] = useState(2);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const lang = location.pathname.startsWith("/id") ? "id" : "en";

  const { testimonials, fetchTestimonials } = useTestimonialStore();

  // 🔹 fetch API
  useEffect(() => {
    fetchTestimonials(lang).finally(() => setLoading(false));
  }, [fetchTestimonials, lang]);

  useEffect(() => {
    const updateSlidesToScroll = () => {
      setSlidesToScroll(window.innerWidth < 768 ? 1 : 2);
    };

    updateSlidesToScroll();
    window.addEventListener("resize", updateSlidesToScroll);

    return () => window.removeEventListener("resize", updateSlidesToScroll);
  }, []);

  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
      align: "center",
      containScroll: "trimSnaps",
      slidesToScroll,
    },
    [Autoplay({ delay: 4000, stopOnInteraction: false })]
  );

  useEffect(() => {
    if (emblaApi) emblaApi.reInit();
  }, [emblaApi, slidesToScroll]);

  if (!testimonials.length) return null;

  return (
    <div className="container-section mx-auto pt-6">
        {loading && <PageLoader />}
      <SectionBox
        title={
          lang === "id"
            ? "Apa Kata Talenta Kita"
            : "What Our Talents Are Saying"
        }
        description={
          lang === "id"
            ? "Pengguna kami menyukai cara mereka mencapai dan meningkatkan nilai mereka"
            : "Our users love how they reach and leveling up their values"
        }
        titleAlign="center"
        titleClassName="text-2xl md:text-3xl text-black"
        background="#ffffff"
      >
        <div className="relative overflow-hidden px-8" ref={emblaRef}>
          <div className="flex">
            {testimonials.map((t) => (
              <div
                key={t.id}
                className="flex-[0_0_100%] sm:flex-[0_0_45%] lg:flex-[0_0_40%] px-3 pb-4 min-h-[250px]"
              >
                <div className="bg-white rounded-2xl shadow-md p-6 h-full flex flex-col justify-between">
                  <p className="text-gray-600 text-sm mb-4">
                    {t.testimony}
                  </p>

                  <div className="flex items-center gap-3 mt-auto">
                    <img
                      src={t.avatar_image}
                      alt={t.name}
                      className="w-12 h-12 rounded-full object-cover"
                    />
                    <div>
                      <p className="text-gray-900 font-semibold ">
                        {t.name}
                      </p>
                      <p className="text-gray-500 text-sm">
                        {t.position}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* gradient fade */}
          <div className="pointer-events-none absolute left-0 top-0 h-full w-12 bg-gradient-to-r from-white to-transparent z-10" />
          <div className="pointer-events-none absolute right-0 top-0 h-full w-12 bg-gradient-to-l from-white to-transparent z-10" />
        </div>
      </SectionBox>
    </div>
  );
}
